import React from 'react'
import PropTypes from 'prop-types'
import { Container, Heading } from '@scentregroup/ui'
import { useEvolvedContext } from '../../context'
import { MarketplaceContainer } from '../marketplace-container'
import style from './index.module.scss'

const PageHeading = ({ title }) => {
  const isEvolved = useEvolvedContext()

  return isEvolved ? (
    <MarketplaceContainer>
      <Heading type="large">{title}</Heading>
    </MarketplaceContainer>
  ) : (
    <Container centred type="large" className={style.heading}>
      <Heading type="extralarge">{title}</Heading>
    </Container>
  )
}

PageHeading.propTypes = {
  title: PropTypes.string.isRequired,
}

export default PageHeading
